module.exports = __webpack_public_path__ + "static/media/patrol(17).303f8ccd.PNG";